import React, {useEffect, useState } from 'react'
import { aggregateTimeArr, getJobId, invertColor } from '../common/util/appUtils' 
import { useDispatch, useSelector } from "react-redux" 
import { closeTaskModal, openTaskModal } from '../Context/ReduxContext';
import ModuleService from '../common/util/ModuleService';
import TimeLogDeleteWarning from './TimeLogDeleteWarning'; 
import ReminderWrapper from './ReminderWrapper'; 
import TimeTrackingWrapper from './TimeTrackingWrapper';
import TaskModal from '../tabs/Task/taskModal';
import TaskService from '../common/util/TaskService';
import moment from 'moment';
import _ from 'lodash';
import { resetTriggerStartStop, settimerObj, settimerTimeTrack, setTimeTrackFlag } from '../Context/ReduxTimerSlice';
import ReportBug from '../navbar/ReportBug';

export default function TrackTimeRemChatSection({history}) {
  const [allTask, setAllTasks] = useState([]);
  const [allJobs, setAllJobs] = useState([]);
  const [timerTimeTrack, setTimerTimeTrack] = useState(0);
  const [timerPrevTimeTrack, setTimerPrevTimeTrack] = useState(0);
  const [timerObj, setTimerObj] = useState(null);
  const [deleteTimeLogObj, setDeleteTimeLogObj] = useState({}); 
  const [timeTrackLogs, setTimeTrackLogs] = useState([]);
  const [timeTrackInterv, setTimeTrackInterv] = useState(0);
  const [timeLogDeleteWarn, setTimeDeleteWarn] = useState(false);
  const [timeTrackClock, setTimeTrackClock] = useState(false);
   const [allClients, setAllClients] = useState([]); 
  const [cachePipeline, setCachePipeline] = useState([]); 
  let timeTrackInitialTime = new Date(Date.now());
  const [cacheDeals, setCacheDeals] = useState([]);
  const triggerStartStop = useSelector(state => state.TimeTrackingSlice.triggerStartStop);
  const timerPrevTimeTrackFromRedux = useSelector(state => state.TimeTrackingSlice.timerPrevTimeTrack);
  const initializeTimeTrackFlag = useSelector(state => state.TimeTrackingSlice.initializeTimeTrackFlag);
  const reduxDispatch = useDispatch();

  useEffect(() => {
  if (triggerStartStop.flag && triggerStartStop.payload) {
    startstopClockTimeTrack(triggerStartStop.payload);
    reduxDispatch(resetTriggerStartStop());
  }
  }, [triggerStartStop]);
  useEffect(() => {
   if(initializeTimeTrackFlag !== null) {
      initializeTimeTrack();
    }
  },[initializeTimeTrackFlag])
  useEffect(()=>{
    setTimerPrevTimeTrack(timerPrevTimeTrackFromRedux);
  },[timerPrevTimeTrackFromRedux])
  useEffect(() =>{
    if(allJobs && timeTrackLogs && allJobs.length > 0 && timeTrackLogs.length > 0) {
      initializeTimeTrack();
    }
  },[allJobs, timeTrackLogs]);
  
  const initializeTimeTrack = () => {
      TaskService.GetCurrentlyRunningTimer()
        .then((res) => {
          if (res) {
            if (!timeTrackClock) {
              setTimeTrackInterv(
                setInterval(() => {
                  let nowTime = new Date(Date.now());
                  let diff = nowTime.getTime() - timeTrackInitialTime.getTime();
                  diff = Math.abs(diff / 1000);
                  timeTrackInitialTime = new Date(nowTime);
                  setTimerTimeTrack((prev) => prev + diff);
                  reduxDispatch(settimerTimeTrack(timerTimeTrack + diff));
                }, 1000)
              );
              let totalTime = 0;
              let filterTimeLog = timeTrackLogs.filter(
                (one) => one.jobId == res.jobId
              );
              if (filterTimeLog.length > 0) {
                totalTime = totalTime + filterTimeLog[0].totaltime;
                setTimerPrevTimeTrack(totalTime);
              }
              let startTime = new Date(Date.now());
              // startTime.setTime(startTime.getTime()-(res.diff*1000)) 
              // res.diff=res.diff+totalTime;
              // startTime.setTime(startTime.getTime() + ((res.diff) * 1000));
              timeTrackInitialTime = new Date(startTime);
  
              setTimerTimeTrack((prev) => prev + res.diff + totalTime);
              reduxDispatch(settimerTimeTrack(timerTimeTrack + res.diff + totalTime));
              reduxDispatch(setTimeTrackFlag(true));
              setTimeTrackClock(true);
              localStorage.setItem("IsTimeTrackRunning", true);
              reduxDispatch(settimerObj(res));
              setTimerObj(res);
              // setRunningTaskLabel(getTaskToolTipLabel(res))
              getAllTimeTrackLogs("all");
            }
          } else {
            if (timeTrackClock) {
              localStorage.setItem("IsTimeTrackRunning", false);
              reduxDispatch(setTimeTrackFlag(false));
              setTimeTrackClock(false);
              timeTrackInitialTime = new Date(Date.now());
              clearInterval(timeTrackInterv);
              reduxDispatch(settimerTimeTrack(0));
              setTimerTimeTrack(0);
              reduxDispatch(settimerObj(null));
              setTimerObj(null);
              // setRunningTaskLabel(null);
              getAllTimeTrackLogs("all");
            }
          }
        })
        .catch((err) => {
          console.error(err);
        });
    };
const startstopClockTimeTrack = async (timerObj) => {
    const userinfo = JSON.parse(localStorage.getItem("userinfo"));
    try {
      if (timeTrackClock) {
        let res = await TaskService.ResumeAndPauseTimeTrack(
          timerObj.timelogId,
          "stop"
        );
        reduxDispatch(setTimeTrackFlag(false));
        setTimeTrackClock(false);
        timeTrackInitialTime = new Date(Date.now());
        clearInterval(timeTrackInterv);
        reduxDispatch(settimerTimeTrack(0));
        setTimerTimeTrack(0);
        reduxDispatch(settimerObj(null));
        setTimerObj(null);
        getAllTimeTrackLogs("all");
        localStorage.setItem("IsTimeTrackRunning", false);
      } else {
        let date = new Date();
        // date.setDate(date.getDate() - 1)
        date = moment(new Date(date)).format("YYYY-MM-DD");
        let result = await TaskService.StartTimeTrack(
          userinfo.email_id,
          date,
          timerObj.jobId
        );
        if (result.response.errors) {
          alert(result.response.errors.message);
        } else {
          let res = await TaskService.GetCurrentlyRunningTimer();
          if (res) {
            setTimeTrackInterv(
              setInterval(() => {
                let nowTime = new Date(Date.now());
                let diff = nowTime.getTime() - timeTrackInitialTime.getTime();
                diff = diff / 1000;
                timeTrackInitialTime = new Date(nowTime);
                setTimerTimeTrack((prev) => prev + diff);
                reduxDispatch(settimerTimeTrack(timerTimeTrack + diff));
              }, 1000)
            );
            let startTime = new Date(Date.now());
            startTime.setTime(startTime.getTime() + res.diff * 1000);
            timeTrackInitialTime = new Date(startTime);
            setTimerTimeTrack((prev) => prev + res.diff);
            reduxDispatch(settimerTimeTrack(timerTimeTrack + res.diff));
            reduxDispatch(setTimeTrackFlag(true));
            setTimeTrackClock(true);
            reduxDispatch(settimerObj(res));
            setTimerObj(res);
            localStorage.setItem("IsTimeTrackRunning", true);
          }
        }
      }
    } catch (err) {
      console.error(err);
    }
  };
 

   const getCalculateTimeTrackLogs = (result) => {
      result = _.cloneDeep(result);
      if (allJobs.length > 0 && cacheDeals.length > 0) {
        try {
          result.forEach((one) => {
            let jobs = [...allJobs];
            let alldeals = [...cacheDeals];
            jobs = jobs.filter((job) => job.projectId == one.projectId);
            if (jobs.length > 0) {
              jobs = jobs[0];
              alldeals = alldeals.filter((one1) => {
                let ids = one1.Project_ID;
                if (ids) {
                  ids = ids.split(",");
                  ids = ids.filter((id) => id);
                  if (ids.includes(jobs.zProjectsProjectRefId)) {
                    return one1;
                  }
                }
              });
  
              if (alldeals.length > 0) {
                alldeals = alldeals[0];
                if (alldeals.Account_Name) {
                  one.name =
                    alldeals.Account_Name.name +
                    "_" +
                    one.projectName +
                    "_" +
                    one.jobName;
                } else {
                  one.name = "" + "_" + one.projectName + "_" + one.jobName;
                }
              }
            }
          });
        } catch (err) {
          console.error(err);
        }
      }
  
      try {
        // result=result.filter(one=>one.jobName=="Upload PW2")
        result?.forEach((obj) => {
          if (obj.timearr) {
            obj.timearr.forEach((oneObj) => {
              oneObj.workDate = obj.workDate;
              oneObj.timerLog = obj.timerLog;
            });
          }
  
          if (!obj.timerLog) {
            //obj.totaltime=(obj.totaltime*60);
  
            obj.toTime = obj.fromTime + obj.totaltime;
  
            if (obj.timearr) {
              obj.timearr.push(obj);
            } else {
              obj.timearr = [obj];
            }
          }
        });
        for (let i = 0; i < result.length; i++) {
          for (let j = i + 1; j < result.length; j++) {
            if (result[i].jobId == result[j].jobId) {
              result[i].hoursInMins =
                result[i].hoursInMins + result[j].hoursInMins;
              result[i].totaltime = result[i].totaltime + result[j].totaltime;
              if (result[j].timearr) {
                result[i].timearr = [...result[i].timearr, ...result[j].timearr];
              } else {
                result[i].timearr = [result[j]];
              }
              result.splice(j, 1);
              j--;
            }
          }
        }
      } catch (err) {
        console.error(err);
      }
      result.forEach((one) => {
        let timeArr = aggregateTimeArr(_.cloneDeep(one.timearr));
        timeArr = timeArr.sort(
          (a, b) => new Date(b.workDate) - new Date(a.workDate)
        );
        if (timeArr.length > 0) {
          one.workDate = timeArr[0].workDate;
        }
      });
      result.forEach((one) => {
        one.timearr = aggregateTimeArr(_.cloneDeep(one.timearr));
      });
  
      result = result.sort((a, b) => new Date(b.workDate) - new Date(a.workDate)); 
      return result;
    };
   const getAllTimeTrackLogs = (taskId) => {
      let userInfo = JSON.parse(localStorage.getItem("userinfo"));
      let startDate = new Date();
      startDate.setDate(1);
      startDate = moment(startDate).format("YYYY-MM-DD");
      let endDate = new Date();
      endDate.setDate(31);
      endDate = moment(endDate).format("YYYY-MM-DD");
      //userinfo.email_id
      TaskService.GetAllTimeTrack(
        "david@srsolardesign.com",
        startDate,
        endDate,
        taskId
      )
        .then((result) => {
          // if(timeTrackClock&&timerObj){
          //   let firstObj=result.filter(one=>one.jobId==timerObj.jobId)
          //   result=result.filter(one=>one.jobId!==timerObj.jobId);
          //   result
          // }
          if(result){
            result = getCalculateTimeTrackLogs(result);
          }
          setTimeTrackLogs(result);
        })
        .catch((err) => {
          console.error(err);
        });
    }; 
  // const { open, taskData, dealObj, taskAction } = useSelector(state => state.AppReduxContext.taskModal);

  const getAllTask = () => {
      TaskService.GetMyTasks()
        .then((result) => {
          for (let i = 0; i < result.length; i++) {
            result[i].JobId = getJobId(result[i].id_string, allJobs);
          }
          setAllTasks(result);
        })
        .catch((err) => {
          console.error(err);
        });
    };
  const getJobsByProjectId = (pid) => {
      TaskService.GetJobsByProjectId(pid)
        .then((result) => {
          if (result) {
            for (let i = 0; i < result.length; i++) {
              result[i].name = result[i].projectName + "-" + result[i].jobName;
            }
            setAllJobs(result);
          } else {
            setAllJobs([]);
          }
        }).catch((err) => { 
          console.error(err);
        }).finally(() => {
          getAllTask();
        });
    };
    const getAllPipeline = () => {
        TaskService.GetAllProjects()
          .then(async (result) => {
            if (result.data.projects) {
              setCachePipeline(result.data.projects);
            } else {
              setCachePipeline([]);
            }
          })
          .catch((err) => {
            console.error(err);
          });
      };
  useEffect(()=>{
   getJobsByProjectId("");
   getAllResourse();
   getAllPipeline();
  },[])
  const getAllResourse = () => {
                ModuleService.GetModuleList("Deals")
                  .then((result) => {
                    if (result.data) { 
                      setCacheDeals(result.data);
                    } else {
                      setCacheDeals([]);
                    }
                  })
                  .catch((err) => {
                    console.error(err);
                  }).finally(()=>{
                    ModuleService.GetModuleList("Accounts")
                      .then((result) => {
                        if (result.data) { 
                          setAllClients(result.data);
                        } else {
                          setAllClients([]);
                        }
                      })
                      .catch((err) => {
                        console.error(err);
                      }); 
                  }); 
              };

  const handleOnOpenTask = (obj) => {
    let tasks = [...allTask];
    let jobs = [...allJobs];
    let alldeals = [...cacheDeals];
    let data=[];
    let projectJobs = jobs.filter((job) => job.projectId == obj.projectId);
    let taskJobs = jobs.filter((job) => job.jobId == obj.jobId);
    if (projectJobs.length > 0) {
      projectJobs = projectJobs[0];
      alldeals = alldeals.filter((one1) => {
        let ids = one1.Project_ID;
        if (ids) {
          ids = ids.split(",");
          ids = ids.filter((id) => id);
          if (ids.includes(projectJobs.zProjectsProjectRefId)) {
            return one1;
          }
        }
      });
      if (alldeals.length > 0) {
        data = alldeals[0];
      }
    }
    if (taskJobs.length > 0) {
      taskJobs = taskJobs[0];
      tasks = tasks.filter(
        (one1) => one1.id_string == taskJobs.zProjectsJobRefId
      );
      if (tasks.length > 0) {
        reduxDispatch(openTaskModal({
                        taskData: tasks[0],
                        dealObj: data,
                        taskAction: "Edit"
                      }));
      }
    }
  };
  

  useEffect(() => {
    if ( cacheDeals.length > 0 && allClients.length > 0 && cachePipeline.length > 0 &&
      allJobs.length > 0 ) {
      getAllTimeTrackLogs("all");
    }
  }, [cacheDeals, allClients, cachePipeline, allJobs]);


  return (<div>
        <TaskModal
          dealObj={{}} 
          setTimerPrevTimeTrack={setTimerPrevTimeTrack}
          setTimerTimeTrack={(data)=>{setTimerTimeTrack(data); reduxDispatch(settimerTimeTrack(data))}}
          timerTimeTrack={timerTimeTrack}
          timerObj={timerObj}
          startstopClockTimeTrack={startstopClockTimeTrack}
          timeTrackFlag={timeTrackClock}
          initializeTimeTrack={initializeTimeTrack} 
          parentTaskObj={{}} 
          taskCreateLocation="Deals" 
          allProject={cachePipeline}
          style="taskdetail-modal-subtask" 
          getallTasks={getAllTask}
          taskDocs={allTask}
          task={{}}
          taskType={"task"}
          taskAction={"Edit"}
          nestedModal={false}
          handleCloseTaskModel={() => reduxDispatch(closeTaskModal())}  
        />
        <TimeLogDeleteWarning
          timeLogDeleteWarn={timeLogDeleteWarn}
          setTimeDeleteWarn={setTimeDeleteWarn}
          deleteTimeLogObj={deleteTimeLogObj}
          getAllTimeTrackLogs={getAllTimeTrackLogs}
        />
        <div className="chat-box-area" style={{marginRight:"4.5rem"}}> 
                        <ReportBug history={history}/>
                        <ReminderWrapper/> 
                        <TimeTrackingWrapper
                          timeTrackClock={timeTrackClock}
                          timerObj={timerObj}
                          timerTimeTrack={timerTimeTrack}
                          timerPrevTimeTrack={timerPrevTimeTrack}
                          setTimerTimeTrack={(data)=>{setTimerTimeTrack(data); reduxDispatch(settimerTimeTrack(data))}}
                          setTimerPrevTimeTrack={setTimerPrevTimeTrack}
                          startstopClockTimeTrack={startstopClockTimeTrack}
                          timeTrackLogs={timeTrackLogs}
                          setDeleteTimeLogObj={setDeleteTimeLogObj}
                          setTimeDeleteWarn={setTimeDeleteWarn}
                          setTimerObj={(data) => {
                            setTimerObj(data);
                            reduxDispatch(settimerObj(data));
                          }} 
                          handleOnOpenTask={handleOnOpenTask} 
                          allJobs={allJobs}  
                          cacheDeals={cacheDeals} 
                          getAllTimeTrackLogs={getAllTimeTrackLogs}
                        />
                      </div>
        </div>)
}
